import { Box } from "@mui/material";
import React, { useState } from "react";
import HeaderCredit from "./HeaderCredit";
import DriverDepositTransactions from "../../CorporateDrivers/DriverSalary/DriverDepositTransactions";

function CreditNote() {
  const [filters, setFilters] = useState({ name: "", status: "", from: "", to: "" });

  return (
    <>
      <HeaderCredit filters={filters} setFilters={setFilters} />
      <Box sx={{ maxWidth: "100%" }}>
        <DriverDepositTransactions filters={filters} initiatedLabel="Lien" />
      </Box>
    </>
  );
}

export default CreditNote;